import { DefaultValues } from "react-hook-form";
import * as yup from "yup";

export const massSmsSchema = yup
  .object({
    userIds: yup
      .array()
      .of(yup.number().required())
      .min(1, "Изберете поне един получател")
      .required("Изберете поне един получател"),
    message: yup.string().required("Съобщението е задължително").max(65, "Съобщението не може да надвишава 65 символа").defined(),
  })
  .required();

export type IMassSmsFormModel = yup.InferType<typeof massSmsSchema>;

export const massSmsFormDefaultValues: DefaultValues<IMassSmsFormModel> = {
  userIds: [],
  message: "",
};
